let SUCCESS_CODE = '001';

export default {
    install(Vue) {
        Object.defineProperty(Vue.prototype, "$successCode", {value: SUCCESS_CODE})
    }
};
